
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/link.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Link","toc":"menu","filename":"docs/x-markdown/demo/codeDemo/link.md","lastUpdated":1764905689000,"description":"中文链接处理，英文如果非标准格式无法处理。"};